import { useSelector } from 'react-redux'
import { Element } from '../../../../../../../common/html/element'
import { formatText } from '../../../../../../../helpers/value'
import { selectScoreRanges } from '../../../../../../common/header/companyInfo/store/slice'

export const CustomScoreCell = ({ val, typeCell }) => {
  const scoreRanges = useSelector(selectScoreRanges(typeCell))
  const { color = '#CCCCCC' } =
    scoreRanges.find(
      (item) => val <= item['scoreRange_Max'] && val >= item['scoreRange_Min'],
    ) || {}

  return (
    <div className="dFlex justifyContentCenter">
      <Element className="fw600" style={{ backgroundColor: color, width: 60 }}>
        {val === 0 || val === '0' ? '0' : formatText(val)}
      </Element>
    </div>
  )
}
